type DispatchFunction = (action: any) => Promise<any>;

type ApiHandlerParams<T> = {
	endpoint: (arg: T, options?: any) => any; // The specific endpoint to call
	args?: T; // Arguments to pass to the endpoint
	dispatch: DispatchFunction; // The dispatch function
	forceRefetch?: boolean; // Whether to force a refetch
};

const apiHandler = async <T, R>({
	endpoint,
	args,
	dispatch,
}: ApiHandlerParams<T>): Promise<{ data: R; args: T }> => {
	try {
		const result = await dispatch(endpoint(args));
		if (result.error) throw new Error(result.error);
		return {
			data: result.data as R,
			args: result.originalArgs as T | undefined,
		};
	} catch (error: any) {
		throw new Error(`API handler failed: ${error.message || 'An unknown error occurred.'}`);
	}
};

export const dataApiHandler = async <T, R>({
	endpoint,
	args,
	dispatch,
	forceRefetch = false,
}: ApiHandlerParams<T>): Promise<R> => {
	const result = await dispatch(endpoint(args, { forceRefetch }));
	if (result.error) throw result.error;
	return result.data;
};

export default apiHandler;
